import React from 'react';

/** Phase 28: isolate lazy-loaded dashboard failures without blank screens. */
export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      const msg = this.state.error.message || "Unexpected error";
      const isChunkError = /Loading chunk [\d]+ failed/i.test(msg) || /ChunkLoadError/i.test(msg);

      return (
        <div className="container py-5">
          <div className="alert alert-danger" role="alert">
            <div className="fw-semibold mb-1">Something went wrong loading this page.</div>
            <p className="small mb-2">{msg}</p>
            {isChunkError ? (
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => window.location.reload()}
              >
                Refresh page
              </button>
            ) : (
              <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.setState({ error: null })}>
                Try again
              </button>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
